// /* global SideDrawer */

// class CartDrawer extends SideDrawer {
//   connectedCallback() {
//     this.bindEvents();
//   }

//   bindEvents() {
//     this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
//     this.closeDrawerViaEventHandler = this.close.bind(this, null);
//     document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
//     document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
//     document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
//     this.addEventListener('on:cart-drawer:before-open', () => {
//       theme.manuallyLoadImages(this);
//       this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
//     });
//     this.addEventListener('on:cart:after-merge', () => {
//       theme.manuallyLoadImages(this);
//       this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
//     });
//   }

//   disconnectedCallback() {
//     document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
//     document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
//     document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
//   }

//   /**
//    * Handle when the drawer is opened via an event
//    * @param {object} evt - Event object.
//    */
//   handleDrawerOpenViaEvent(evt) {
//     this.open(evt.detail ? evt.detail.opener : null);
//   }

//   /**
//    * Trigger refresh of contents
//    */
//   cartRefreshHandler() {
//     this.querySelector('cart-form').refresh();
//   }

//   /**
//    * Update section's cart-form element with new contents
//    * @param {string} html - Whole-section HTML.
//    */
//   updateFromCartChange(html) {
//     this.querySelector('cart-form').refreshFromHtml(html);
//   }
// }

// window.customElements.define('cart-drawer', CartDrawer);

 /* global SideDrawer */

class CartDrawer extends SideDrawer {
    connectedCallback() {
      this.bindEvents();
    }
  
    bindEvents() {
      this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
      this.closeDrawerViaEventHandler = this.close.bind(this, null);
      document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
      document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
      document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
      this.addEventListener('on:cart-drawer:before-open', () => {
        theme.manuallyLoadImages(this);
        this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
      });
      this.addEventListener('on:cart:after-merge', () => {
        theme.manuallyLoadImages(this);
        this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
      });
    }
  
    disconnectedCallback() {
      document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
      document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
      document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    }
  
    /**
     * Handle when the drawer is opened via an event
     * @param {object} evt - Event object.
     */
    handleDrawerOpenViaEvent(evt) {
      console.log('Cart drawer open!!');
      if (typeof this.open === 'function') {
        this.open(evt.detail ? evt.detail.opener : null);
      } else {
        console.error('The open method is not defined on CartDrawer.');
      }
      this.removeFreeProduct(); // Call removeFreeProduct when the cart drawer is opened
    }
  
    /**
     * Trigger refresh of contents
     */
    cartRefreshHandler() {
      this.querySelector('cart-form').refresh();
    }
  
    /**
     * Update section's cart-form element with new contents
     * @param {string} html - Whole-section HTML.
     */
    updateFromCartChange(html) {
      this.querySelector('cart-form').refreshFromHtml(html);
    }
  
    /**
     * Function to remove a free product when certain conditions are met.
     */
    removeFreeProduct() {
      console.log('Checking for free products to remove...');
      const allRemoveBtn = document.querySelectorAll('.cart-item__remove');
      if (allRemoveBtn) {
        allRemoveBtn.forEach((btn) => {
          btn.addEventListener('click', () => {
            const updatedItem = btn.dataset;
            console.log('UPDATED ITEM: ', updatedItem);
            if (
              updatedItem &&
              (
                updatedItem.id.startsWith('49377174618400') ||
                updatedItem.id.startsWith('49377174651168') ||
                updatedItem.id.startsWith('49377174683936')
              )
            ) {
              this.removeItemFromShopifyCart(50156475547936);
            }
          });
        });
      }
    }
  
    /**
     * Helper method to remove an item from the Shopify cart.
     * @param {number} itemId - The ID of the item to remove.
     */
    async removeItemFromShopifyCart(itemId) {
      try {
        const response = await fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            updates: {
              [itemId]: 0,
            },
          }),
        });
  
        if (response.ok) {
          const updatedCart = await response.json();
          console.log('Item removed successfully:', updatedCart);
          document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', {
            bubbles: true,
          }));
        } else {
          throw new Error('Failed to update cart');
        }
      } catch (error) {
        console.error('Error removing item from Shopify cart:', error);
      }
    }
  }
  
  window.customElements.define('cart-drawer', CartDrawer);
  
